import type { CSSProperties, ReactNode } from 'react';

export type RecommendationVariant = 'neutral' | 'warning' | 'danger' | 'info';

interface RecommendationPanelProps {
  icon?: string;
  title: string;
  body: string;
  action?: ReactNode;
  variant?: RecommendationVariant;
  style?: CSSProperties;
}

const VARIANT_CLASS: Record<RecommendationVariant, string> = {
  neutral: 'acc-recommendation--neutral',
  warning: 'acc-recommendation--warning',
  danger: 'acc-recommendation--danger',
  info: 'acc-recommendation--info',
};

export default function RecommendationPanel({
  icon = '→',
  title,
  body,
  action,
  variant = 'info',
  style,
}: RecommendationPanelProps) {
  return (
    <div
      className={['acc-recommendation', VARIANT_CLASS[variant]].join(' ')}
      style={style}
    >
      <div className="acc-recommendation__icon">{icon}</div>
      <div className="acc-recommendation__content">
        <div className="acc-recommendation__title">{title}</div>
        <div className="acc-recommendation__body">{body}</div>
      </div>
      {action && <div className="acc-recommendation__action">{action}</div>}
    </div>
  );
}
